export enum PickListSelectionType {
  SingleSelect = 1,
  MultiSelect = 2,
}
